<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-taxes',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowTypeTaxes',
      'isShowRateTaxes',
      'isShowDateFromTaxes',
      'isShowDateToTaxes',
      'isShowCountryTaxes',
      'isShowEnabledTaxes',
      'isShowProjectTaxes'
    ])
  },
  methods: {
    ...mapActions([
      'isShowTypeTaxesAction',
      'isShowRateTaxesAction',
      'isShowDateFromTaxesAction',
      'isShowDateToTaxesAction',
      'isShowCountryTaxesAction',
      'isShowEnabledTaxesAction',
      'isShowProjectTaxesAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'type':
          isShow = !this.isShowTypeTaxes
          this.isShowTypeTaxesAction(isShow)
          break
        case 'rate':
          isShow = !this.isShowRateTaxes
          this.isShowRateTaxesAction(isShow)
          break
        case 'project':
          isShow = !this.isShowProjectTaxes
          this.isShowProjectTaxesAction(isShow)
          break
        case 'country':
          isShow = !this.isShowCountryTaxes
          this.isShowCountryTaxesAction(isShow)
          break
        case 'dateFrom':
          isShow = !this.isShowDateFromTaxes
          this.isShowDateFromTaxesAction(isShow)
          break
        case 'dateTo':
          isShow = !this.isShowDateToTaxes
          this.isShowDateToTaxesAction(isShow)
          break
        case 'enable':
          isShow = !this.isShowEnabledTaxes
          this.isShowEnabledTaxesAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('taxes.taxes_table.project'), value: 'project', show: this.isShowProjectTaxes
        }, {
          text: this.$t('taxes.taxes_table.type'), value: 'type', show: this.isShowTypeTaxes
        }, {
          text: this.$t('taxes.taxes_table.rate'), value: 'rate', show: this.isShowRateTaxes
        }, {
          text: this.$t('taxes.taxes_table.country'), value: 'country', show: this.isShowCountryTaxes
        }, {
          text: this.$t('taxes.taxes_table.validity_date_from'), value: 'dateFrom', show: this.isShowDateFromTaxes
        }, {
          text: this.$t('taxes.taxes_table.validity_date_to'), value: 'dateTo', show: this.isShowDateToTaxes
        }, {
          text: this.$t('taxes.taxes_table.enable'), value: 'enable', show: this.isShowEnabledTaxes
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
